module.exports = __webpack_public_path__ + "static/organicleopard-9edc07671bcfdaf3048640ccbc3f9a2d.jpeg";